module.exports = __webpack_public_path__ + "img/yassir.639a8639.svg";